// This must always be first
import "./require";

// Third-party dependencies
import "popper.js";
import "bootstrap";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit.js";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "fluidbox";
import "smartmenus";
import "smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js";

// Theme scripts
import { AdvancedForm } from "./advanced-forms";
import { iframeResize, loadInFrame } from "./ajax-iframe";
import { getScrollbarWidth } from "./css-vars";
import { better_wpcf7_forms } from "./forms";
import { ajax_search } from "./search";
import { woocommerceFeatures } from "./woocommerce";
import { shareButtons } from "./share-buttons";

const $ = jQuery;

$( () => {

  $( 'form.af-form' ).each( function ( this: HTMLFormElement ) {
    new AdvancedForm( this );
  } );

  document.documentElement.style.setProperty( '--scrollbar-width', getScrollbarWidth() + 'px' );

  ajax_search();
  woocommerceFeatures();
  loadInFrame(); // loads content into iframe
  iframeResize(); // Automatically resizes iframes
  shareButtons();

  better_wpcf7_forms();
  $( '.gallery a.thumbnail' ).fluidbox();
  $( '.gallery a.thumbnail img' ).each( function ( this: HTMLImageElement ) {
    if ( this.src !== this.getAttribute( 'src' ) ) {
      $( this ).replaceWith( $( this.outerHTML ) );
    }
  } );

  // flyout menu
  $( '.navbar-collapse.width' ).on( 'show.bs.collapse hide.bs.collapse', function ( e ) {
    $( 'body' ).toggleClass( 'menu-visible' );
  } );

  //contact page radio button change
  $('.radio-buttons input').on( 'change', function(){
    var $this = $(this);
    if ($this.is(':checked')) {
      $('.radio-buttons label').removeClass('active');
      $this.parent('label').addClass('active');
    }
  });

  //logo scroll
  $( window ).on( 'resize scroll', function ( e ) {
    if ( $( window ).scrollTop() > $( '.page-header .fixed-top' ).height() && !$( '.page-header .fixed-top' ).is( '.scroll' ) ) {
      $( '.page-header .fixed-top' ).addClass( 'scroll' );
    } else if ( $( window ).scrollTop() < $( '.page-header .fixed-top' ).height() && $( '.page-header .fixed-top' ).is( '.scroll' ) ) {
      $( '.page-header .fixed-top' ).removeClass( 'scroll' );
    }
  } );
  

  var prevDefault = null;
  $(window).bind('scroll', function() {
    //console.groupCollapsed('scroll event');
        $('.fl-row.fl-row-full-width:visible').reverse().each(function() {
            var textpanel = $(this);
            var position = textpanel.position().top - $(window).scrollTop();
            //console.log('panel',this);
            //console.log('position',position);
            
            //means window scrolls to this panel
            if (position <= 0) {
              //console.log('current panel',this);
              var thisDefault = textpanel.is('.light-bg');
              //console.log('is dark', thisDefault);
              if(prevDefault !== thisDefault){
                //debugger;
                //console.log('dark changed');
                prevDefault = thisDefault;
                if(prevDefault){
                  $('#menu-top-menu').removeClass('navbar-inverse').addClass('navbar-default');
                  $('header.page-header').removeClass('header-inverse').addClass('header-default');
                }else{
                  $('#menu-top-menu').removeClass('navbar-default').addClass('navbar-inverse');
                  $('header.page-header').removeClass('header-default').addClass('header-inverse');
                }
              }
              
        return false;
            }
        }); 
        //console.groupEnd();       
  });
  jQuery.fn.reverse = [].reverse;

} );
